<template>
  <section v-if="paginationObject" class="table-nav-controls">
    <section class="table-nav-controls__container">
      <BaseButton
        rounded
        color="primary"
        :disabled="!paginationObject.prev_page_url"
        class="table-nav-controls__button"
        @click="selectedPage = paginationObject.current_page - 1"
      >
        <IconChevronLeft
          color="white"
          :height="45"
          :width="45"
          class="table-nav-controls__button-icon"
        />
      </BaseButton>
      <BaseSelectDropdown
        :id="`table-nav-controls-${id}`"
        v-model="selectedPage"
        :options="formattedPageOptions"
        class="table-nav-controls__dropdown"
      >
        Page {{ paginationObject.current_page }} of
        {{ paginationObject.last_page }}
      </BaseSelectDropdown>
      <BaseButton
        rounded
        color="primary"
        :disabled="!paginationObject.next_page_url"
        class="table-nav-controls__button"
        @click="selectedPage = paginationObject.current_page + 1"
      >
        <IconChevronRight
          color="white"
          :height="45"
          :width="45"
          class="table-nav-controls__button-icon"
        />
      </BaseButton>
    </section>
  </section>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';
  import BaseSelectDropdown from '~/components/base/BaseSelectDropdown.vue';
  import IconChevronLeft from '~/components/icon/IconChevronLeft.vue';
  import IconChevronRight from '~/components/icon/IconChevronRight.vue';

  export default {
    name: 'TableNavControls',
    components: {
      BaseButton,
      BaseSelectDropdown,
      IconChevronLeft,
      IconChevronRight,
    },
    props: {
      id: {
        type: String,
        required: true,
      },
      paginationObject: {
        type: Object,
        required: false,
        default: false,
      },
    },
    data: () => ({
      selectedPage: 0,
    }),
    computed: {
      formattedPageOptions() {
        if (!this.paginationObject?.last_page) return [];
        const pages = Array.from(
          { length: this.paginationObject.last_page },
          (_, i) => i + 1
        );
        return pages.map((page) => ({
          value: page,
          label: `Page ${page} of ${this.paginationObject.last_page}`,
        }));
      },
    },
    watch: {
      selectedPage(page) {
        let pageToNavigateTo = page;

        if (page < 1) {
          pageToNavigateTo = 1;
        } else if (page > this.paginationObject.last_page) {
          pageToNavigateTo = this.paginationObject.last_page;
        }

        if (pageToNavigateTo === this.paginationObject.current_page) return;

        this.$emit('page-selected', pageToNavigateTo);
      },
    },
    mounted() {
      this.selectedPage = this.paginationObject?.current_page
        ? this.paginationObject.current_page
        : 0;
    },
  };
</script>

<style lang="scss" scoped>
  .table-nav-controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
    padding: 0;
    background-color: transparent;
    width: 100%;
    overflow: hidden;

    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;

      width: 100%;
      max-width: 350px;
    }

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 40px;
      height: 40px;

      padding: 0;
      margin: 0;
      border: none;
      outline: none;
      cursor: pointer;
    }

    &__dropdown {
      flex: 1;
    }
  }
</style>
